import { Injectable } from '@angular/core';
import { FeatureFlags } from '../api';

@Injectable()
export class FeatureFlagsService {
  
  constructor() {  }

  isEnabled(feature: FeatureFlags) {
      
    const flagsRaw = sessionStorage.getItem('flags');

    //no flags present
    if (!flagsRaw) return false;

    try {
        const flags: string[] = JSON.parse(flagsRaw);
        let checkValue =  feature.toString().toLowerCase();

        return flags.some(flag => flag.toLowerCase() === checkValue);
    } 
    catch (e) {
        console.error('Invalid flags in sessionStorage:', e);
        return false;
    }
  }
  
}
